module.exports = __webpack_public_path__ + "img/DocYes.aa7c1d21.png";